var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_80_8711",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.600098 0.599976H17.216V17.4831H0.600098V0.599976Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_80_8711)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87865 12.7745C5.17733 12.7745 2.98251 10.5797 2.98251 7.87834C2.98251 5.17702 5.17733 2.9822 7.87865 2.9822C10.58 2.9822 12.7748 5.17702 12.7748 7.87834C12.7748 10.5797 10.58 12.7745 7.87865 12.7745ZM13.694 12.2682C14.6132 11.0486 15.176 9.52934 15.176 7.87834C15.176 3.86388 11.8931 0.599976 7.87865 0.599976C3.86419 0.599976 0.600098 3.86388 0.600098 7.87834C0.600098 11.893 3.86419 15.1569 7.87865 15.1569C9.37938 15.1569 10.7863 14.6879 11.9494 13.9C11.9681 13.919 11.9681 13.919 11.9869 13.9375L15.176 17.1266C15.4011 17.3517 15.72 17.4832 16.0201 17.4832C16.3203 17.4832 16.6392 17.3705 16.8643 17.1266C17.3333 16.6576 17.3333 15.9073 16.8643 15.4383L13.694 12.2682Z",
    fill: "white"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.ed3b38c7.svg";
export { ForwardRef as ReactComponent };